/* TAC unit search
   Shopify's predictive search matches collections on the title only, so "1 bn 8th"
   never finds "1st Battalion, 8th Marines". This script loads a theme-built index of
   every collection (assets/tac-unit-index.json, built by tools/build_unit_index.py)
   and matches it with military shorthand: bn, regt, bde, sqdn, cav, 1/8, 1-8, CVN-68,
   VMFA-232, OIF, ordinals. Unit matches render first in the header flydown, on the
   search results page, and in the homepage hero search. */
(function (w, d) {
  'use strict';
  if (w.TACUnitSearch) return;

  var INDEX_URL = w.TAC_UNIT_INDEX_URL || '';
  var COLLECTIONS_URL = (w.Theme && w.Theme.routes && w.Theme.routes.collections_url) || '/collections';

  var STOP = { the: 1, of: 1, and: 1, an: 1, merchandise: 1, collection: 1, gear: 1, u: 1, s: 1, us: 1 };
  var CANON = { reconnaissance: 'recon', armoured: 'armored', armour: 'armor', regimental: 'regiment' };
  var ALIASES = {
    bn: 'battalion', btn: 'battalion', batt: 'battalion',
    regt: 'regiment', rgt: 'regiment', reg: 'regiment',
    bde: 'brigade', brig: 'brigade',
    div: 'division',
    co: 'company', coy: 'company',
    plt: 'platoon',
    sqdn: 'squadron', sqn: 'squadron', sq: 'squadron', sqd: 'squadron',
    grp: 'group', gp: 'group',
    wg: 'wing',
    cav: 'cavalry',
    inf: 'infantry',
    arty: 'artillery',
    abn: 'airborne',
    armd: 'armored', armor: 'armored',
    mech: 'mechanized',
    eng: 'engineer', engr: 'engineer',
    sig: 'signal',
    med: 'medical',
    avn: 'aviation',
    hq: 'headquarters',
    usmc: 'marine', mar: 'marine',
    usn: 'navy',
    nam: 'vietnam',
    usaf: ['air', 'force'], uscg: ['coast', 'guard'],
    fa: ['field', 'artillery'], ada: ['air', 'defense', 'artillery'],
    mp: ['military', 'police'],
    pir: ['parachute', 'infantry', 'regiment'],
    acr: ['armored', 'cavalry', 'regiment'],
    bct: ['brigade', 'combat', 'team'], rct: ['regimental', 'combat', 'team'],
    id: ['infantry', 'division'], ad: ['armored', 'division'],
    mef: ['marine', 'expeditionary', 'force'], meu: ['marine', 'expeditionary', 'unit'],
    mardiv: ['marine', 'division'], maw: ['marine', 'aircraft', 'wing'], mag: ['marine', 'aircraft', 'group'],
    mcas: ['marine', 'corps', 'air', 'station'],
    lar: ['light', 'armored', 'reconnaissance'],
    ceb: ['combat', 'engineer', 'battalion'],
    mwss: ['marine', 'wing', 'support', 'squadron'], mals: ['marine', 'aviation', 'logistics', 'squadron'],
    sfg: ['special', 'forces', 'group'], sf: ['special', 'forces'], sog: ['special', 'operations', 'group'],
    fs: ['fighter', 'squadron'], tfs: ['tactical', 'fighter', 'squadron'],
    bs: ['bomb', 'squadron'], bg: ['bomb', 'group'], bw: ['bomb', 'wing'],
    fw: ['fighter', 'wing'], aw: ['airlift', 'wing'],
    ars: ['air', 'refueling', 'squadron'], arw: ['air', 'refueling', 'wing'], amw: ['air', 'mobility', 'wing'],
    afb: ['air', 'force', 'base'], ang: ['air', 'national', 'guard'],
    oif: ['operation', 'iraqi', 'freedom'], oef: ['operation', 'enduring', 'freedom'],
    gwot: ['global', 'war', 'on', 'terror'],
    wwii: ['world', 'war', 'ii'], ww2: ['world', 'war', 'ii'], wwi: ['world', 'war', 'i'], ww1: ['world', 'war', 'i']
  };
  var BRANCH_LABEL = { usmc: 'USMC', army: 'Army', navy: 'Navy', usaf: 'USAF', uscg: 'USCG', usaaf: 'USAAF', ussf: 'USSF' };

  function singular(t) {
    if (t.length > 3 && t.charAt(t.length - 1) === 's' && t.charAt(t.length - 2) !== 's') return t.slice(0, -1);
    return t;
  }
  function canon(t) { return CANON[t] || singular(t); }

  /* "1st Battalion, 8th Marines" -> ["1","battalion","8","marine"]; "1 bn 8th" -> the same. */
  function tokenize(text) {
    var s = String(text || '').toLowerCase();
    s = s.replace(/&/g, ' and ').replace(/[’']/g, '');
    s = s.replace(/\b(\d+)(st|nd|rd|th)\b/g, '$1');
    s = s.replace(/[^a-z0-9]+/g, ' ');
    s = s.replace(/([a-z])(\d)/g, '$1 $2').replace(/(\d)([a-z])/g, '$1 $2');
    var raw = s.split(' '), out = [];
    for (var i = 0; i < raw.length; i++) {
      var t = raw[i];
      if (!t) continue;
      var ex = ALIASES[t];
      if (ex) {
        if (typeof ex === 'string') ex = [ex];
        for (var k = 0; k < ex.length; k++) out.push(canon(ex[k]));
        continue;
      }
      if (STOP[t]) continue;
      out.push(canon(t));
    }
    return out;
  }

  /* Strip the "product_type:x AND " prefix Empire adds when a category filter is set. */
  function clean(terms) {
    terms = String(terms || '');
    var i = terms.indexOf(' AND ');
    if (i > -1 && /^(product_type|tag|searchfilter_)/i.test(terms)) terms = terms.slice(i + 5);
    return terms.trim();
  }

  var index = null, loading = null;
  function ready() {
    if (index) return Promise.resolve(true);
    if (!INDEX_URL || !w.fetch || !w.Promise) return Promise.resolve(false);
    if (!loading) {
      loading = w.fetch(INDEX_URL, { credentials: 'omit' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j || !j.items) return false;
          index = j.items.map(function (it) {
            var title = tokenize(it[1]), aliases = it[4] || [], alts = [title], all = title.slice();
            for (var a = 0; a < aliases.length; a++) {
              var at = tokenize(aliases[a]);
              if (at.length) { alts.push(at); all = all.concat(at); }
            }
            if (aliases.length) alts.push(all);
            return { handle: it[0], title: it[1], branch: it[2] || '', count: it[3] || 0, tokens: all, alts: alts, url: COLLECTIONS_URL + '/' + it[0] };
          });
          return true;
        })
        .catch(function () { return false; });
    }
    return loading;
  }

  function score(tokens, q, last) {
    var used = [], total = 0, lastPos = -1, ordered = true;
    for (var i = 0; i < q.length; i++) {
      var qt = q[i], isNum = /^\d+$/.test(qt), isLast = i === last, best = 0, bestPos = -1;
      for (var j = 0; j < tokens.length; j++) {
        if (used[j]) continue;
        var tt = tokens[j], sc = 0;
        if (tt === qt) sc = 3;
        else if (isNum) { if (isLast && /^\d+$/.test(tt) && tt.indexOf(qt) === 0) sc = 1; }
        else if (tt.indexOf(qt) === 0 && (qt.length >= 2 || isLast)) sc = qt.length >= 3 ? 1.5 : 1;
        if (sc > best) { best = sc; bestPos = j; if (sc === 3) break; }
      }
      if (!best) return 0;
      used[bestPos] = true;
      total += best;
      if (bestPos < lastPos) ordered = false;
      lastPos = bestPos;
    }
    if (ordered) total += 1;
    /* Penalize leftover words, but not repeats of words already matched
       ("1st Infantry Division (1st ID)" expands to the same three words twice). */
    var extra = 0;
    for (var m = 0; m < tokens.length; m++) {
      if (used[m]) continue;
      if (q.indexOf(tokens[m]) > -1) continue;
      extra++;
    }
    total -= 0.2 * extra;
    return total;
  }

  function match(query, limit) {
    if (!index) return [];
    var raw = String(query || ''), q = tokenize(raw);
    if (!q.length || (q.length === 1 && q[0].length < 2)) return [];
    var slash = raw.indexOf('/') > -1, last = q.length - 1, hits = [];
    for (var i = 0; i < index.length; i++) {
      var it = index[i], s = 0;
      /* Title, each alias (nickname, motto) and the combined list; the best one counts. */
      for (var a = 0; a < it.alts.length; a++) {
        var sa = score(it.alts[a], q, last);
        if (sa > s) s = sa;
      }
      if (s <= 0) continue;
      if (slash && it.tokens.indexOf('marine') > -1) s += 1;
      hits.push({ it: it, s: s });
    }
    hits.sort(function (a, b) {
      return b.s - a.s || b.it.count - a.it.count || a.it.title.length - b.it.title.length;
    });
    return hits.slice(0, limit || 5).map(function (h) { return h.it; });
  }

  function render(container, items, opts) {
    opts = opts || {};
    container.innerHTML = '';
    if (!items.length) { container.hidden = true; container.classList.remove('tac-units--has-items'); return; }
    var head = d.createElement('div');
    head.className = 'tac-units__head';
    head.textContent = opts.heading || 'Units';
    if (opts.sub) { var sm = d.createElement('small'); sm.textContent = opts.sub; head.appendChild(sm); }
    var ul = d.createElement('ul');
    ul.className = 'tac-units__list';
    items.forEach(function (it) {
      var li = d.createElement('li'); li.className = 'tac-units__item';
      var a = d.createElement('a'); a.className = 'tac-units__link'; a.href = it.url;
      var b = d.createElement('span');
      b.className = 'tac-units__branch' + (it.branch ? ' tac-units__branch--' + it.branch : '');
      b.textContent = BRANCH_LABEL[it.branch] || 'Collection';
      var t = d.createElement('span'); t.className = 'tac-units__title'; t.textContent = it.title;
      a.appendChild(b); a.appendChild(t);
      if (it.count > 0) {
        var c = d.createElement('span'); c.className = 'tac-units__count';
        c.textContent = it.count + (it.count === 1 ? ' item' : ' items');
        a.appendChild(c);
      }
      li.appendChild(a); ul.appendChild(li);
    });
    container.appendChild(head);
    container.appendChild(ul);
    container.hidden = false;
    container.classList.add('tac-units--has-items');
  }

  /* "Request it" goes to the request page (window.TAC_REQUEST_URL overrides). */
  function requestUrl() {
    if (w.TAC_REQUEST_URL) return w.TAC_REQUEST_URL;
    var root = ((w.Theme && w.Theme.routes && w.Theme.routes.root_url) || '/').replace(/\/$/, '');
    return root + '/pages/custom-designs';
  }

  function renderEmpty(container, opts) {
    opts = opts || {};
    container.innerHTML = '';
    var head = d.createElement('div');
    head.className = 'tac-units__head';
    head.textContent = opts.heading || 'Units';
    var ul = d.createElement('ul');
    ul.className = 'tac-units__list';
    var li = d.createElement('li');
    li.className = 'tac-units__item tac-units__item--empty';
    var txt = d.createElement('span');
    txt.className = 'tac-units__empty';
    txt.textContent = 'Not built yet. ';
    var a = d.createElement('a');
    a.className = 'tac-units__request';
    a.href = requestUrl();
    a.textContent = 'Request it';
    li.appendChild(txt); li.appendChild(a); ul.appendChild(li);
    container.appendChild(head);
    container.appendChild(ul);
    container.hidden = false;
    container.classList.add('tac-units--has-items');
  }

  /* Custom storefront events for web pixels: one per settled query per surface. */
  var trackTimers = {}, trackLast = {};
  function track(surface, query, items) {
    var S = w.Shopify;
    if (!S || !S.analytics || typeof S.analytics.publish !== 'function') return;
    query = String(query || '').trim();
    if (!query) return;
    if (trackTimers[surface]) clearTimeout(trackTimers[surface]);
    trackTimers[surface] = setTimeout(function () {
      trackTimers[surface] = null;
      var key = surface + '|' + query.toLowerCase();
      if (trackLast[surface] === key) return;
      trackLast[surface] = key;
      var top = items.length ? items[0] : null;
      try {
        S.analytics.publish('tac_unit_search', { surface: surface, query: query, matches: items.length, top_handle: top ? top.handle : null, top_title: top ? top.title : null });
        if (!items.length) S.analytics.publish('tac_unit_search_no_match', { surface: surface, query: query });
      } catch (e) { /* analytics must never break search */ }
    }, 600);
  }

  /* Empire sizes the flydown from its visible child; re-measure after we add rows. */
  function remeasure(container) {
    var fly = container.closest ? container.closest('[data-live-search-flydown]') : null;
    if (!fly) return;
    var vis = fly.querySelector(':scope > .visible');
    if (vis) fly.style.setProperty('--open-height', vis.scrollHeight + 'px');
  }

  function fillFlydown(container) {
    if (container.getAttribute('data-tac-filled')) return;
    container.setAttribute('data-tac-filled', '1');
    var terms = clean(container.getAttribute('data-tac-terms'));
    var shopify = container.parentNode ? container.parentNode.querySelector('[data-tac-shopify-collections]') : null;
    ready().then(function (ok) {
      if (!ok || !d.contains(container)) return;
      var items = match(terms, 5), seen = {};
      items.forEach(function (i) { seen[i.handle] = 1; });
      if (shopify) {
        var links = shopify.querySelectorAll('a[data-handle]');
        for (var i = 0; i < links.length && items.length < 6; i++) {
          var h = links[i].getAttribute('data-handle');
          if (!h || seen[h]) continue;
          seen[h] = 1;
          items.push({ handle: h, title: links[i].textContent.replace(/\s+merchandise\s*$/i, '').trim(), branch: '', count: 0, url: links[i].getAttribute('href') });
        }
        shopify.hidden = true;
      }
      if (items.length) render(container, items, { heading: 'Units' });
      else if (tokenize(terms).length >= 2) renderEmpty(container, { heading: 'Units' });
      else render(container, [], {});
      track('header', terms, items);
      remeasure(container);
    });
  }

  function watchResults(el) {
    if (el.getAttribute('data-tac-watched') || !w.MutationObserver) return;
    el.setAttribute('data-tac-watched', '1');
    var mo = new MutationObserver(function () {
      var c = el.querySelector('[data-tac-units]');
      if (c) fillFlydown(c);
    });
    mo.observe(el, { childList: true, subtree: false });
    var now = el.querySelector('[data-tac-units]');
    if (now) fillFlydown(now);
  }

  function fillPage(container) {
    var terms = clean(container.getAttribute('data-tac-terms'));
    if (!terms) return;
    ready().then(function (ok) {
      if (!ok) return;
      var items = match(terms, 8);
      if (items.length) render(container, items, { heading: 'Units', sub: 'for "' + terms + '"' });
      else if (tokenize(terms).length >= 2) renderEmpty(container, { heading: 'Units' });
      track('search_page', terms, items);
    });
  }

  function init() {
    var results = d.querySelectorAll('[data-live-search-results]');
    for (var i = 0; i < results.length; i++) watchResults(results[i]);
    var pages = d.querySelectorAll('[data-tac-units-page]');
    for (var k = 0; k < pages.length; k++) fillPage(pages[k]);
  }

  /* Warm the index the moment anyone touches a search box. */
  d.addEventListener('focusin', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-live-search-input], [data-th-search-input], input[type="search"], input[name="q"]')) ready();
  }, true);

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  d.addEventListener('shopify:section:load', init);

  /* A few real units at random (branch set, enough products), for hints and placeholders. */
  function sample(n, minCount) {
    if (!index) return [];
    var pool = index.filter(function (it) { return it.branch && it.count >= (minCount || 1); });
    var out = [], used = {}, tries = 0;
    while (out.length < n && tries < n * 25 && pool.length) {
      var it = pool[Math.floor(Math.random() * pool.length)];
      tries++;
      if (used[it.handle]) continue;
      used[it.handle] = 1;
      out.push(it);
    }
    return out;
  }

  w.TACUnitSearch = { ready: ready, match: match, sample: sample, tokenize: tokenize, clean: clean, render: render, renderEmpty: renderEmpty, requestUrl: requestUrl, track: track };
})(window, document);
